import React, {useEffect, useState} from 'react';
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab, {tabClasses} from "@mui/joy/Tab";
import TabPanel from "@mui/joy/TabPanel";
import {PaymentMethodsTab} from "./paymentMethods/PaymentMethodsTab";
import {StatisticsTab} from "./statistics/StatisticsTab";
import {ProfitAdjustmentsTab} from "./profitAdjustmentsTab/ProfitAdjustmentsTab";
import {useLocation, useNavigate} from "react-router-dom";

export function Finances() {
    const navigate = useNavigate();
    const location = useLocation();

    const topSlugs = ['methods', 'profit-adjustments', 'stats'] as const;
    const methodSlugs = ['methods-deposit', 'methods-withdraw'] as const;
    const statsSlugs = ['stats-balance', 'stats-methods', 'stats-charts', 'stats-tables'] as const;

    const getIndicesFromHash = () => {
        const hash = (location.hash || '').replace('#', '').toLowerCase();
        let topIndex = 0;
        let methodsIndex = 0;
        let statsIndex = 0;
        if (hash) {
            if (hash.startsWith('methods')) {
                topIndex = 0;
                const mi = methodSlugs.indexOf(hash as typeof methodSlugs[number]);
                methodsIndex = mi >= 0 ? mi : 0;
            } else if (hash.startsWith('stats')) {
                topIndex = 2;
                const si = statsSlugs.indexOf(hash as typeof statsSlugs[number]);
                statsIndex = si >= 0 ? si : 0;
            } else {
                const ti = topSlugs.indexOf(hash as typeof topSlugs[number]);
                topIndex = ti >= 0 ? ti : 0;
            }
        }
        return { topIndex, methodsIndex, statsIndex };
    };

    const [{ topIndex, methodsIndex, statsIndex }, setIndices] = useState(getIndicesFromHash());

    useEffect(() => {
        setIndices(getIndicesFromHash());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.hash]);

    const handleTopTabChange = (_: React.SyntheticEvent | null, value: number | string | null) => {
        const idx = typeof value === 'number' ? value : 0;
        const slug = topSlugs[idx] || topSlugs[0];
        navigate(`#${slug}`, { replace: false });
    };

    const handleMethodsInnerChange = (idx: number) => {
        const slug = methodSlugs[idx] || methodSlugs[0];
        navigate(`#${slug}`, { replace: false });
    };

    const handleStatsInnerChange = (idx: number) => {
        const slug = statsSlugs[idx] || statsSlugs[0];
        navigate(`#${slug}`, { replace: false });
    };

    return (
        <React.Fragment>
            <Box
                component="main"
                className="MainContent"
                sx={{
                    px: { xs: 2, md: 6 },
                    pt: {
                        xs: 'calc(12px + var(--Header-height))',
                        sm: 'calc(12px + var(--Header-height))',
                        md: 3,
                    },
                    pb: { xs: 2, sm: 2, md: 3 },
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: 0,
                    height: '100dvh',
                    gap: 1,
                }}
            >
                <Typography level="h2" component="h1" sx={{ mb: 2 }}>
                    Финансы
                </Typography>

                {/* Основные табы */}
                <Tabs 
                    value={topIndex} 
                    onChange={handleTopTabChange}
                    sx={{bgcolor: 'transparent', flex: 1, display: 'flex', flexDirection: 'column'}}
                >
                    <TabList
                        tabFlex={1}
                        size="sm"
                        sx={{
                            pl: {xs: 0, md: 4},
                            justifyContent: 'left',
                            [`&& .${tabClasses.root}`]: {
                                fontWeight: '600',
                                flex: 'initial',
                                color: 'text.tertiary',
                                [`&.${tabClasses.selected}`]: {
                                    bgcolor: 'transparent',
                                    color: 'text.primary',
                                    '&::after': {
                                        height: '2px',
                                        bgcolor: 'primary.500',
                                    },
                                },
                            },
                        }}
                    >
                        <Tab sx={{borderRadius: '6px 6px 0 0'}} indicatorInset value={0}>
                            Методы оплаты
                        </Tab>
                        <Tab sx={{borderRadius: '6px 6px 0 0'}} indicatorInset value={1}>
                            Корректировки прибыли
                        </Tab>
                        <Tab sx={{borderRadius: '6px 6px 0 0'}} indicatorInset value={2}>
                            Статистика
                        </Tab>
                    </TabList>
                    
                    <TabPanel value={0} sx={{ flex: 1, overflow: 'auto' }}>
                        <PaymentMethodsTab currentTabIndex={methodsIndex} onTabChange={handleMethodsInnerChange} />
                    </TabPanel>
                    
                    <TabPanel value={1} sx={{ flex: 1, overflow: 'auto' }}>
                        <ProfitAdjustmentsTab />
                    </TabPanel>
                    
                    <TabPanel value={2} sx={{ flex: 1, overflow: 'auto' }}>
                        <StatisticsTab currentTabIndex={statsIndex} onTabChange={handleStatsInnerChange} />
                    </TabPanel>
                </Tabs>
            </Box>
        </React.Fragment>
    );
}
